import StoreManager from '../models/StoreManager';

/**
 * SessionStoreManager handles persisting and retrieving data from the browser's sessionStorage.
 * Extends a base StoreManager (assumed to be a class or interface).
 */
class SessionStoreManager extends StoreManager {
    private storeName: string;

    constructor(storeName: string) {
        super();
        this.storeName = storeName;
    }

    /**
     * Serializes and saves data to sessionStorage.
     * @param data - The data object to be stored.
     */
    save(data: Record<string, any>): void {
        try {
            sessionStorage.setItem(this.storeName, JSON.stringify(data));
        } catch (e) {
            console.error('Error saving to sessionStorage:', e);
        }
    }

    /**
     * Retrieves and parses data from sessionStorage.
     * @returns The parsed data object or an empty object if parsing fails or data is missing.
     */
    load(): Record<string, any> {
        try {
            const item = sessionStorage.getItem(this.storeName);

            return item ? JSON.parse(item) : {};
        } catch (e) {
            console.error('Error loading from sessionStorage:', e);

            return {};
        }
    }
}

export default SessionStoreManager;
